import { render, staticRenderFns } from "./DeliveryMenuDetailDialog.vue?vue&type=template&id=77b669cf&scoped=true"
import script from "./DeliveryMenuDetailDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuDetailDialog.vue?vue&type=style&index=0&id=77b669cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b669cf",
  null
  
)

export default component.exports